const FENCED_CODE_BLOCK = /(```[\s\S]*?```)/g;
const DISPLAY_MATH_BLOCK = /\$\$([\s\S]*?)\$\$/g;
const UNESCAPED_CURRENCY_DOLLAR = /(^|[^\\])\$(?=\s*\d)/g;

function escapeCurrencyDollars(math: string): string {
  return math.replace(UNESCAPED_CURRENCY_DOLLAR, (_match, prefix: string) => `${prefix}\\$`);
}

function toDisplayMathBlock(match: string, math: string, offset: number, source: string): string {
  const end = offset + match.length;
  const before = source.slice(Math.max(0, offset - 2), offset);
  const after = source.slice(end, end + 2);
  const leadingBreak = offset === 0 || before === '\n\n' ? '' : before.endsWith('\n') ? '\n' : '\n\n';
  const trailingBreak = end === source.length || after === '\n\n' ? '' : after.startsWith('\n') ? '\n' : '\n\n';
  return `${leadingBreak}$$\n${escapeCurrencyDollars(math).trim()}\n$$${trailingBreak}`;
}

/**
 * Normalizes common LLM-generated currency notation inside display math.
 *
 * Example: `$$\\frac{$100}{$61}$$` becomes
 * `$$\\frac{\\$100}{\\$61}$$`, which KaTeX can render safely.
 * Fenced code blocks and currency outside `$$...$$` are left untouched.
 */
export function normalizeLatexCurrency(markdown: string): string {
  return markdown
    .split(FENCED_CODE_BLOCK)
    .map((segment) => {
      if (segment.startsWith('```')) return segment;
      return segment.replace(DISPLAY_MATH_BLOCK, toDisplayMathBlock);
    })
    .join('');
}
